<template>
  <div class="row row-xs">
    <div
      class="col-xs-12 col-sm-4 col-md-3 col-lg-3 col-xl-3 col-xxl-2"
      v-for="(t, i) in tasks"
      :key="i"
    >
      <div class="card overflow-hidden">
        <div class="ht-100 bg-info d-flex align-items-center">
          <h1 class="text-center text-white wd-100p">EMBED</h1>
        </div>
        <div class="card-body tx-13 pd-b-10 pd-x-15">
          <div
            class="d-flex align-items-center"
            @click="$emit('on-detail', t)"
            role="button"
          >
            <feather
              type="globe"
              :size="32"
              :stroke-width="1"
              class="text-primary mg-r-10"
            ></feather>
            <h6>
              <a class="link-02">{{ t.task }}</a>
            </h6>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    box: {
      type: Object,
      default: () => {}
    },
    tasks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    showDetail(t) {
      if (this.$route.params.bot == 435) {
        this.$emit("on-detail", t);
      } else {
        this.$router.push({
          name: "lmsLessonView",
          params: {
            id: this.$route.params.id,
            cid: this.$route.params.cid,
            bid: this.box.id,
            iid: t.id,
            bot: this.box.ot
          }
        });
      }
    }
  }
};
</script>

<style></style>
